import produce from 'immer';
import { SET_PASSENGERS, SET_PASSENGER_SELECT, SET_ALL_PASSENGER_SELECT } from './actions';
const initialState = {};
function passengersReducer(state = initialState, { type, payload }) {
    return produce(state, draft => {
        switch (type) {
            case SET_PASSENGERS: {
                Object.assign(draft, payload);
                break;
            }
            case SET_PASSENGER_SELECT: {
                const { id, selected } = payload;
                const ids = Array.isArray(id) ? id : [id];
                ids.forEach(travellerId => {
                    draft[travellerId] = selected;
                });
                break;
            }
            case SET_ALL_PASSENGER_SELECT: {
                const { selected } = payload;
                Object.keys(draft).forEach(id => (draft[id] = selected));
                break;
            }
        }
    });
}
export default passengersReducer;
